<template>
  <v-dialog
    v-model="dialog"
    width="500px">
    <div class="dialog-container">
      <h2>Edit Limit</h2>
      <div class="form-item">
        <span>Refer Request Limit</span>
        <v-input
          v-model="inputLimit" />
      </div>
      <div class="dialog-footer">

        <v-button @click="dialog = false">Cancel</v-button>

        <v-button
          type="success"
          @click="handlerSave">Save</v-button>

      </div>
    </div>
  </v-dialog>
</template>
<script>
import { updateReferralRequestLimit } from '@/api/request'
export default {
  name: 'EditLimit',
  props: {
    userId: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      dialog: false,
      inputLimit: 5
    }
  },
  watch: {
    limit: {
      immediate: true,
      handler(val) {
        this.inputLimit = val
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerSave() {
      this.network().updateReferralRequestLimit()
    },
    network() {
      return {
        updateReferralRequestLimit: async () => {
          const { data } = await updateReferralRequestLimit({
            user_id: this.userId,
            request_limit: this.inputLimit
          })
          this.dialog = false
          this.$emit('update')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .dialog-container {
    padding: 15px;
    .el-checkbox {
      margin: 10px 0;
    }
    p {
      padding-bottom: 15px;
    }
    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 10px;
    }
  }
</style>